import Law from '../../../profile/law';

function ShopRules() {
  return (
    <div>
      <Law />
    </div>
  );
}

export default ShopRules;
